import React from "react";
import BaseProductsBrowser from "@menu/components/BaseProductsBrowser";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";
import ActionsSortFilter from "../../baseTheme/elements/filters/ActionsSortFilter";
import AppliedFiltersSection from "src/themes/baseTheme/elements/filters/AppliedFiltersSection";

const SearchProductsList = dynamic(() =>
  import("@menu/components/SearchProductsList").catch(
    logModuleLoadError("SearchProductsList", {critical: true})
  )
);
const ShowCaseProductsList = dynamic(() =>
  import("@menu/components/ShowCaseProductsList").catch(
    logModuleLoadError("ShowCaseProductsList", {critical: true})
  )
);
const ProductsList = dynamic(() =>
  import("@menu/components/ProductsList").catch(
    logModuleLoadError("ProductsList", {critical: true})
  )
);

export default function DefaultCategorizedProductsBrowser({hideFilters}) {
  return (
    <BaseProductsBrowser
      render={({category, filters, onListUpdate}) => {
        const hasFilters = filters.hasFilters();

        return (
          <>
            {hasFilters && <AppliedFiltersSection filters={filters} />}

            {!filters.search && filters.category && (
              <ProductsList
                title={category ? category.getName() : ""}
                onListUpdate={onListUpdate}
                description={category ? category.getDescription() : undefined}
                category={category}
                ActionFiltersInHeader={<ActionsSortFilter filters={filters} />}
                filters={filters}
              />
            )}

            {!filters.search && !filters.category && !category && (
              <div>
                {!hideFilters && <ActionsSortFilter filters={filters} />}
                <ShowCaseProductsList filters={filters} />
              </div>
            )}

            {filters.search && (
              <SearchProductsList onListUpdate={onListUpdate} filters={filters} />
            )}
          </>
        );
      }}
    />
  );
}
